import { Button } from '@/components'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface GoToListDialogButtonProps {
  /** リスト表示をするかどうかのフラグ */
  showItemList: boolean
  selectedType: 1 | 2 | 3 | number
  // 0: None 1: Download 2: Product 3: Entry 4: Photo Frame 5: Coupon
  presentType: Api.ConvertedPresentTypeId
  /** ユーザーが獲得した特典の数 */
  presentItemListLength?: number
  /** ダウンロードコンテンツ用のリストを開くボタンを押下した時の挙動 */
  onHandleShowDialogRewardsListForDownloadContents: () => void
  /** 特典アイテムのリストを開くボタンを押下した時の挙動 */
  onHandleShowDialogRewardsList: () => void
}

export const GoToListDialogButton = ({
  showItemList,
  selectedType,
  presentType,
  presentItemListLength,
  onHandleShowDialogRewardsListForDownloadContents,
  onHandleShowDialogRewardsList,
}: GoToListDialogButtonProps) => {
  const { t } = useTranslation()
  if (!showItemList) {
    return null
  }
  if (!presentItemListLength || presentItemListLength <= 0) {
    return null
  }

  return (
    <>
      {selectedType === 3 && (
        <>
          {presentType === 'Download' ? (
            <>
              {/* ダウンロードコンテンツの場合（賞品表示の方法が「商品名」＋「DLボタン」） */}
              <div className="mt-6">
                <Button
                  text={t('reward_detail.lottery_results_list', '抽選結果一覧')}
                  width="w-9/12"
                  onClick={onHandleShowDialogRewardsListForDownloadContents}
                  borderColor="border-[#cbcbcb]"
                  bgColor="bg-[#cbcbcb]"
                />
              </div>
            </>
          ) : (
            <>
              {/* 上記以外の通常の場合（賞品表示の方法が「取得日時」＋「獲得ボタン」） */}
              <div className="mt-6">
                <Button
                  text={t('reward_detail.lottery_results_list', '抽選結果一覧')}
                  width="w-9/12"
                  onClick={onHandleShowDialogRewardsList}
                  borderColor="border-[#cbcbcb]"
                  bgColor="bg-[#cbcbcb]"
                />
              </div>
            </>
          )}
        </>
      )}
      {selectedType !== 3 && (
        <>
          {presentType === 'Download' ? (
            <>
              <>
                {/* ダウンロードコンテンツの場合（賞品表示の方法が「商品名」＋「DLボタン」） */}
                <div className="mt-6">
                  <Button
                    text={t('reward_detail.received_prize_list', '獲得賞品一覧')}
                    width="w-9/12"
                    onClick={onHandleShowDialogRewardsListForDownloadContents}
                    borderColor="border-[#cbcbcb]"
                    bgColor="bg-[#cbcbcb]"
                  />
                </div>
              </>
            </>
          ) : (
            <>
              {/* 上記以外の通常の場合（賞品表示の方法が「取得日時」＋「獲得ボタン」） */}
              <div className="mt-6">
                <Button
                  text={t('reward_detail.received_prize_list', '獲得賞品一覧')}
                  width="w-9/12"
                  onClick={onHandleShowDialogRewardsList}
                  borderColor="border-[#cbcbcb]"
                  bgColor="bg-[#cbcbcb]"
                />
              </div>
            </>
          )}
        </>
      )}
    </>
  )
}
